import { render, staticRenderFns } from "./CbsTableViewParam.vue?vue&type=template&id=28f95ad8&scoped=true"
import script from "./CbsTableViewParam.vue?vue&type=script&lang=js"
export * from "./CbsTableViewParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f95ad8",
  null
  
)

export default component.exports